exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "textarea.form-control{font-size:1rem}.form-textarea-container{padding-bottom:10px}.form-textarea{font-weight:400}.form-textarea.form-textarea-error,.form-textarea.form-textarea-error:focus{border:1px solid #dd0342}.text-area-validation-error{color:#dd0342;font-size:.75rem;font-weight:400}.text-area-required-text{position:absolute;top:5px;right:0;font-size:.5625rem;font-weight:400;text-align:right;text-transform:uppercase;color:#dd0342}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/form/FormTextarea/FormTextarea.scss
 ** module id = 1248
 ** module chunks = 0
 **/